<template>
  <div id="app">
    <app-header />
    <router-view />
    <div class="copyright">&copy; {{ getCurrentYear }} | hopnami</div>
    <stream-player />
    <app-ads />
  </div>
</template>

<script>
import api from '@/api';

import { Ads, Header, StreamPlayer } from '@/components';
export default {
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  },
  components: {
    'app-ads': Ads,
    'app-header': Header,
    'stream-player': StreamPlayer
  },

  async created() {
    await this.mixerStatus();
    await this.twitchStatus();
    this.setInitialPlatform();
  },

  // set mixer/twitch status in store
  methods: {
    async mixerStatus() {
      const data = await api.checkMixerStatus();
      if (!data) return;
      this.$store.commit('setMixerLiveStatus', data.online);
    },
    async twitchStatus() {
      const data = await api.checkTwitchStatus();
      if (!data) return;
      // Old v3 api...
      // const online = data.stream ? true : false;
      const online = data.data.length > 0;
      // console.log(online);
      this.$store.commit('setTwitchLiveStatus', online);
    },
    setInitialPlatform() {
      let status = {
        mixer: this.$store.state.mixerLiveStatus,
        twitch: this.$store.state.twitchLiveStatus
      };
      if (!status.mixer && status.twitch) {
        this.$store.commit('changePlayer', 'twitch');
      } else {
        this.$store.commit('changePlayer', 'mixer');
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  font-family: 'Staatliches', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.copyright {
  bottom: 0;
  color: rgba(#fff, 0.75);
  font-size: 0.75em;
  // font-weight: 800;
  letter-spacing: 0.1em;
  margin: 15px;
  position: absolute;
  right: 0;
}
</style>
